/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsBlog = {
  init: function($section){
   this.$section = $section
   
    // Add settings from schema to current object
    Shopify.theme.jsBlog = $.extend(this, Shopify.theme.getSectionData($section));
     let blogsSlider = this.$section.find('.blog-slider');
    if(blogsSlider.length){
   this.createSlider(blogsSlider);
      
    }
     
    if(this.enable_filter == true) {
      $('#blog_filter').on('change', function() {
        Shopify.theme.jsBlog.blogFilter();
      });
    }

  },
 
   createSlider: function(blogsSlider) {
 $(blogsSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      pageDots: true,
      contain: true,
      prevNextButtons: true,
      initialIndex: 0,
    groupCells: true,
     arrowShape: { 
  x0: 10,
  x1: 60, y1: 50,
  x2: 60, y2: 40,
  x3: 20
},
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(blogsSlider).on( 'settle.flickity', function() {
            $(blogsSlider).flickity('resize')
          });
        }
      }
    });

  },
  blogFilter: function() {
    let url = $('#blog_filter').val();
    window.location = url;
  },
  unload: function($section) {
    $('#blog_filter').off();
  }
}
/******/ })()
;




